import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BriefsPage from './BriefsPage';
import ClustersPage from './ClustersPage';
import UrlExplorerPage from './UrlExplorerPage';
import TrendingPage from './TrendingPage';
import TopMentionsPage from './TopMentionsPage';

/**
 * Nested routes for the Universe section. Real pages replace the
 * placeholders as later beads ship.
 *
 * Paths are relative to `/clusters` (mounted via `path="/clusters/*"` in
 * `App.tsx`).
 *
 * d68.6:  `overview` is now the real Universe bubble page.
 * d68.10: `briefs` is now the real My Briefs page.
 * d68.7:  `url-explorer` is now the real URL Explorer page.
 */

export const CLUSTERS_SUB_ROUTES: { path: string; label: string }[] = [
    { path: 'trending', label: 'Trending today' },
    { path: 'overview', label: 'Universe' },
    { path: 'top-mentions', label: 'Top Mentions' },
    { path: 'briefs', label: 'My Briefs' },
    { path: 'url-explorer', label: 'URL Explorer' },
];

const ClustersRoutes: React.FC = () => {
    return (
        <Routes>
            <Route index element={<Navigate to="trending" replace />} />
            <Route path="overview" element={<ClustersPage />} />
            <Route path="trending" element={<TrendingPage />} />
            <Route path="top-mentions" element={<TopMentionsPage />} />
            <Route path="briefs" element={<BriefsPage />} />
            <Route path="url-explorer" element={<UrlExplorerPage />} />
            <Route path="*" element={<Navigate to="trending" replace />} />
        </Routes>
    );
};

export default ClustersRoutes;
